export default {
  consumer: 'consumers',
  business: 'merchants-ecom',
}
